import { render, staticRenderFns } from "./perfil-sidebar.vue?vue&type=template&id=0f916a8d&scoped=true&"
import script from "./perfil-sidebar.vue?vue&type=script&lang=ts&"
export * from "./perfil-sidebar.vue?vue&type=script&lang=ts&"
import style0 from "./perfil-sidebar.vue?vue&type=style&index=0&id=0f916a8d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f916a8d",
  null
  
)

export default component.exports